@if (alertDetalheRota === true) {
  <div class="alert-fatura">
    <div class="acoes my-4">
      <button
        class="btn-icon"
        (click)="fecharModalRota()"
        aria-label="Fechar modal de rota">
        <i class="fa fa-arrow-left c-secondary" aria-hidden="true"></i>
      </button>
      <button
        class="btn-icon p-0 border-0 bg-transparent"
        (click)="imprimirRota()"
        aria-label="Imprimir rota">
        <i class="fa fa-print c-secondary" aria-hidden="true"></i>
      </button>
    </div>
    <div class="documento printMe" id="content">
      @if (dadosRota === null) {
        <div class="pt-5">
          <div class="text-center">
            <output class="spinner-border c-primary">
              <span class="visually-hidden">Consultando detalhes da rota ...</span>
            </output>
          </div>
          <p class="legenda-spinner">Consultando detalhes da rota ...</p>
        </div>
      }
    </div>
  </div>
}